import { z } from 'zod';

export const ProductDetailBannerDTOTypes = {
    Marketing: z.literal('MARKETING'),
    GiftWithPurchase: z.literal('GWP'),
    Loyalty: z.literal('FIDELITY'),
};
